import { CalendarMonthOutlined } from '@mui/icons-material';
import { Box, Chip, Stack, Typography } from '@mui/material';

import { ProjectAbstract } from '@/domain/project/entities/project.entity';
import { BackButton } from '@/ui/components/button/BackButton';
import { translate } from '@/ui/i18n';
import { formatProjectDatesFromProject } from '@/ui/utils/format-project-dates';
import { getProjectState } from '@/ui/utils/project-state';

import { PageProjectHeaderImage } from './PageProjectHeaderImage';

export function PageProjectHeader({
  project,
  backButtonText,
  onClickBack,
  rightComponent,
}: {
  project: ProjectAbstract;
  backButtonText: string;
  onClickBack: () => void;
  rightComponent?: React.ReactNode;
}) {
  return (
    <Stack sx={{ gap: 3 }}>
      <BackButton onClick={onClickBack} text={backButtonText} />
      <Stack
        sx={{ display: 'flex', flexDirection: 'row', gap: 3, flexWrap: 'wrap' }}
      >
        <PageProjectHeaderImage image={project.image} />
        <Stack>
          <ProjectTags project={project} />
          <ProjectName project={project} />
          <ProjectDates project={project} />
        </Stack>
        <Box sx={{ marginLeft: 'auto' }}>{rightComponent}</Box>
      </Stack>
    </Stack>
  );
}

function ProjectTags({ project }: { project: ProjectAbstract }) {
  return (
    <Stack sx={{ display: 'flex', flexDirection: 'row', gap: 1 }}>
      {project.type && (
        <Chip label={translate(`ProjectType.${project.type}`)} />
      )}
      {project.startDate && project.endDate && (
        <Chip label={getProjectState(project)} />
      )}
    </Stack>
  );
}

function ProjectName({ project }: { project: ProjectAbstract }) {
  return (
    <Typography variant="h5" sx={{ mt: 1 }}>
      {project.name}
    </Typography>
  );
}

function ProjectDates({ project }: { project: ProjectAbstract }) {
  return (
    <>
      {project.startDate && project.endDate && (
        <Typography
          color="text.secondary"
          sx={{ display: 'flex', alignItems: 'center', mt: 1, mb: 2 }}
        >
          <CalendarMonthOutlined sx={{ mr: 1, color: '#A29BAE' }} />
          {formatProjectDatesFromProject(project)}
        </Typography>
      )}
    </>
  );
}
